import RMLossAttachmentModal from './RM_loss_attachment-modal.vue'
export default RMLossAttachmentModal
